<template>
  <div class="my-6 flex flex-col relative">
    <button class="filterBtn w-max" @click="changeMenuState">
      <ChevronDownIcon class="chevron" v-if="!openMenu" />
      <ChevronUpIcon class="chevron" v-if="openMenu" />
      <p class="ml-1 pr-4 text-greyishBrown text-base">{{getFilterTrans.order_by}}</p>
    </button>

    <div v-show="openMenu" class="dropdown-content">
      <button class="filterBtnOpen w-max" @click="changeMenuState">
        <ChevronDownIcon class="chevron" v-if="!openMenu" />
        <ChevronUpIcon class="chevron" v-if="openMenu" />
        <p class="ml-2 text-greyishBrown text-base">{{getFilterTrans.order_by}}</p>
      </button>
      <div class="optionsList mt-5 mb-4 mr-9">
        <div class="optionItem" v-for="opt in filterOptions" :key="opt.id" @click="changeOption(opt)">
          <div :class="{ 'selectedOpt': opt.type === filter.type}">
            {{opt[codeLang]}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mb-4 max-w-600px">
    <label for="nameFilter" class="block mb-1 font-medium text-typo-typo
  softDark">{{getFilterTrans.find_by_name}}</label>
    <v-select
      :options="participationsFiltered"
      :clearable="false"
      label="cms_establishment_name"
      :placeholder="getFilterTrans.find_placeholder"
      v-model="word"
      :reduce="participation => participation.cms_establishment_name"
      :getOptionKey="option => 'cms_file'"
      @option:selected="selectedRestaurant"
      @search:focus="focusSearch"
      class="select-auto">
      <!-- eslint-disable-next-line -->
      <template #no-options="{ search, searching, loading }">
        {{getFilterTrans.no_options}}
      </template>
    </v-select>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapMutations, mapGetters } from 'vuex'
import ChevronUpIcon from '@/components/ChevronUpIcon.vue'
import ChevronDownIcon from '@/components/ChevronDownIcon.vue'
import router from '@/router/index.js'

export default {
  name: 'Filter',
  components: {
    ChevronUpIcon,
    ChevronDownIcon
  },
  data () {
    return {
      openMenu: false,
      word: null
    }
  },
  computed: {
    ...mapState(['filter', 'filterOptions', 'filterWord', 'participationsFiltered', 'codeLang']),
    ...mapGetters(['getFilterTrans'])
  },
  methods: {
    ...mapMutations(['changeFilter', 'changeFilterWord', 'getParticipationsFiltered', 'getParticipationsPaginated', 'setPromotionByName', 'setCurrentPage', 'changeLoading']),
    changeMenuState () {
      this.openMenu = !this.openMenu
    },
    changeOption (opt) {
      this.openMenu = !this.openMenu
      this.changeLoading(true)
      this.changeFilter(opt)
      this.getParticipationsFiltered()
      this.setCurrentPage(1)
      this.getParticipationsPaginated(true)
      router.push({ path: `/${this.$route.params.alias_url}` })
      this.changeLoading(false)
    },
    filtrar () {
      this.getParticipationsFiltered()
      this.setCurrentPage(1)
      this.getParticipationsPaginated(true)
    },
    selectedRestaurant () {
      this.changeFilterWord(this.word)
      this.setPromotionByName()
      this.setCurrentPage(1)
      this.getParticipationsPaginated(true)
    },
    focusSearch () {
      this.changeFilterWord(null)
      this.word = null
      this.filtrar()
    }
  }
}
</script>

<style>
.select-auto .vs__dropdown-toggle, .select-auto .vs__dropdown-menu {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-color: var(--primary);
  border-radius: 0.75rem;
  border-width: 2px;
  margin-top: 0.25rem;
  padding-top: 0.0625rem;
  padding-bottom: 0.375rem;
  --tw-shadow-color: 0, 0, 0;
  --tw-shadow: 0 1px 2px 0 rgba(var(--tw-shadow-color), 0.05);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  width: 100%;
}
.select-auto .vs__dropdown-toggle:focus, .select-auto .vs__dropdown-menu:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
@media (min-width: 640px) {
  .select-auto .vs__dropdown-toggle, .select-auto .vs__dropdown-menu {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.select-auto .vs__clear, .select-auto .vs__open-indicator {
  margin-right: 0.25rem;
  fill: var(--primary) !important;
}
.select-auto .vs__dropdown-option--highlight {
  background-color: var(--primary);
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.select-auto .vs__search::placeholder {
  color: gray;
}
</style>

<style scoped>
.filterBtn {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-color: var(--primary);
  border-radius: 0.75rem;
  border-width: 2px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-size: 1.25rem;
  line-height: 1.75rem;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  position: relative;
}
.filterBtnOpen {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-size: 1.25rem;
  line-height: 1.75rem;
  padding-top: 10px;
  padding-bottom: 10px;
  position: relative;
}
.filterBtnOpen:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.filterBtnOpen:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.arrow {
  width: 15px;
}
.menuHeader {
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.75rem;
  margin-right: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.dropdown-content {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-color: var(--primary);
  border-radius: 0.75rem;
  border-width: 2px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  padding-left: 1.75rem;
  padding-right: 1.25rem;
  position: absolute;
  top: 0px;
  --tw-shadow-color: 0, 0, 0;
  --tw-shadow: 0 20px 25px -5px rgba(var(--tw-shadow-color), 0.1), 0 10px 10px -5px rgba(var(--tw-shadow-color), 0.04);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  z-index: 2;
}
.optionsList {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  text-align: left;
}
.optionItem {
  cursor: pointer;
  margin-bottom: 0.5rem;
}
.selectedOpt {
  font-weight: 600;
}
.chevron {
  color: var(--primary);
}
</style>
